
import { useState } from "react";
import { Link } from "react-router-dom";

import logo from "../assets/logo.png";


import {
  FaFacebookF,
  FaInstagram,
  FaSnapchatGhost,
  FaTiktok
} from "react-icons/fa";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <nav className="navbar">

        {/* LEFT */}
        <div className="nav-left">
          <div
            className={`menu-btn ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>

          <img src={logo} className="logo" alt="logo" />
          <span>Jumeirah</span>
        </div>

        {/* RIGHT SOCIAL */}
        {/* <div className="nav-social">
          <a href="https://www.facebook.com/people/Jumeirah-Chauffeuring/61586141420211/" target="_blank" rel="noreferrer">
            <img src={facebook} alt="facebook" />
          </a>
          <a href="https://www.instagram.com/jumeirahjc" target="_blank" rel="noreferrer">
            <img src={instagram} alt="instagram" />
          </a>
          <a href="https://www.snapchat.com/@jumeirahjc" target="_blank" rel="noreferrer">
            <img src={snapchat} alt="snapchat" />
          </a>
          <a href="https://www.tiktok.com/@jumeirah_jc" target="_blank" rel="noreferrer">
            <img src={tiktok} alt="tiktok" />
          </a>
        </div> */}
        <div className="nav-social">

          <a
            href="https://www.facebook.com/people/Jumeirah-Chauffeuring/61586141420211/"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebookF />
          </a>

          <a
            href="https://www.instagram.com/jumeirahjc"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram />
          </a>

          <a
            href="https://www.snapchat.com/@jumeirahjc"
            target="_blank"
            rel="noreferrer"
          >
            <FaSnapchatGhost />
          </a>

          <a
            href="https://www.tiktok.com/@jumeirah_jc"
            target="_blank"
            rel="noreferrer"
          >
            <FaTiktok />
          </a>

        </div>
      </nav>

      {/* SIDE MENU */}
      <div className={`side-menu ${menuOpen ? "active" : ""}`}>
        <div className="side-menu-content">

          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link>
          <Link to="/trips" onClick={() => setMenuOpen(false)}>Trips</Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>

        </div>
      </div>

      {/* OVERLAY */}
      {menuOpen && (
        <div
          className="menu-overlay"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}
    </>
  );
}

export default Navbar;